import { gql, useMutation } from "@apollo/client";

export const INVOICE_TAG_APPROVAL_MUTATION = gql`
  mutation (
    $tagId: String!
    $invoiceId: String!
    $tenantId: String!
    $approval: Boolean!
  ) {
    updateInvoiceTagApproval(
      tagId: $tagId
      invoiceId: $invoiceId
      tenantId: $tenantId
      approval: $approval
    ) {
      tagId
      invoiceId
      tenantId
      approval
    }
  }
`;

export const useUpdateInvoiceTagApproval = () => {
  const [updateInvoiceTagApproval] = useMutation(INVOICE_TAG_APPROVAL_MUTATION);
  return updateInvoiceTagApproval;
};
